import * as Yup from 'yup';

export default Yup.object().shape({
    studentId: Yup.number()
        .min(0, 'Invalid Value')
        .required('Required'),
    status: Yup.number()
        .required('Required'),
});